export default {
  methods: {
    setPictures({ logo: key = '', pictures = [] }) {
      if (!pictures) {
        return [];
      }
      return [
        ...(pictures && pictures),
        ...(key ? [{
          key,
          isLogo: true,
        }] : []),
      ];
    },
  },
};
